import { render, staticRenderFns } from "./maintain_manage.vue?vue&type=template&id=c38f2b54&scoped=true"
import script from "./maintain_manage.vue?vue&type=script&lang=js"
export * from "./maintain_manage.vue?vue&type=script&lang=js"
import style0 from "./maintain_manage.vue?vue&type=style&index=0&id=c38f2b54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c38f2b54",
  null
  
)

export default component.exports